import * as React from 'react';
import type { SVGProps } from 'react';
const SvgArrowDown = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={17} fill="none" {...props}>
    <path fill="#616061" d="M10 8.5h4v2l-6 6-6-6v-2h4v-8h4z" />
  </svg>
);
export default SvgArrowDown;
